import { MonthlyOrderingBudget, MonthlySalesTarget } from '@/hooks/api/models';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentTeam } from '@/providers/TeamProvider';
import { useEffect, useState } from 'react';
import { toastError, toastSuccess } from '@/lib/toast';
import { useCreateMonthlyOrderingBudgets } from '@/hooks/api/0360_create_monthly_ordering_budget';
import { InputPrice } from '@/components/element/Form/InputPrice';

type Props = {
  monthlyOrderingBudget: MonthlyOrderingBudget;
};
export const MonthlyOrderingBudgetElement = ({ monthlyOrderingBudget }: Props) => {
  const { setShowLoading } = useLoading();
  const { _w_, me, _t_, isAdmin } = useCurrentTeam();
  const [selected, setSelected] = useState<boolean>(false);
  const [amount, setAmount] = useState<string>(String(monthlyOrderingBudget.amount));
  const { mutate, data, isPending, error } = useCreateMonthlyOrderingBudgets();

  const onEditClick = () => {
    mutate({ identifier: _w_!.identifier, team_id: _t_!.id, year_month: monthlyOrderingBudget.year_month, amount: Number(amount) || 0 });
  };

  useEffect(() => setShowLoading(isPending), [isPending]);

  useEffect(() => {
    if (data) {
      monthlyOrderingBudget.amount = data.amount;
      setSelected(false);
      toastSuccess('発注予算を編集しました');
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      const msgs: string[] = (error as any).response.data.errors || [];
      if (msgs.length > 0) toastError(msgs[0]);
    }
  }, [error]);

  return (
    <tr>
      <td className="text-xs text-dark">
        {String(monthlyOrderingBudget.year_month)
          .match(/.{1,4}/g)
          ?.join('/')}
      </td>
      {selected ? (
        <>
          <td className="text-xs text-wrap">
            <div className="input-group">
              <InputPrice onChange={setAmount} classNames={'text-xs'} value={amount} />
              {/*<input type="number" className="form-control text-end text-xs" min={0} value={amount} onChange={(e) => setAmount(e.target.value)} />*/}
            </div>
          </td>
          <td className="text-end">
            {isAdmin && (
              <>
                <button type="button" className="btn btn-icon-only btn-outline-secondary me-1" onClick={() => setSelected(false)}>
                  <i className="fas fa-undo"></i>
                </button>
                <button type="button" className="btn btn-icon-only bg-gradient-dark" onClick={() => onEditClick()}>
                  <i className="fas fa-check-circle"></i>
                </button>
              </>
            )}
          </td>
        </>
      ) : (
        <>
          <td className="text-xs text-dark text-end">¥{monthlyOrderingBudget.amount.toLocaleString()}</td>
          <td className="text-end">
            {isAdmin && (
              <button type="button" className="btn btn-icon-only bg-gradient-success" onClick={() => setSelected(true)}>
                <i className="fas fa-edit"></i>
              </button>
            )}
          </td>
        </>
      )}
    </tr>
  );
};
